module.exports = __webpack_public_path__ + "img/Fernando.40892612.png";